import React from "react";
import { default as WListItemText } from "@mui/material/ListItemText";

function ListItemText(props) {
  return <WListItemText {...props} />;
}

export default ListItemText;
